import { render } from "./CustomModal.vue?vue&type=template&id=8f8e7458"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"

import "./CustomModal.vue?vue&type=style&index=0&id=8f8e7458&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__